import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensServicesDeliveryChannel} from './citizens-services-delivery-channel.model';
import * as CitizensServicesDeliveryChannelActions from './citizens-services-delivery-channel.actions';

export const citizensServicesDeliveryChannelsFeatureKey = 'citizensServicesDeliveryChannels';

export interface State extends EntityState<CitizensServicesDeliveryChannel> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServicesDeliveryChannel> = createEntityAdapter<CitizensServicesDeliveryChannel>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesDeliveryChannelActions.addCitizensServicesDeliveryChannel,
    (state, action) => adapter.addOne(action.citizensServicesDeliveryChannel, state)
  ),
  on(CitizensServicesDeliveryChannelActions.upsertCitizensServicesDeliveryChannel,
    (state, action) => adapter.upsertOne(action.citizensServicesDeliveryChannel, state)
  ),
  on(CitizensServicesDeliveryChannelActions.addCitizensServicesDeliveryChannels,
    (state, action) => adapter.addMany(action.citizensServicesDeliveryChannels, state)
  ),
  on(CitizensServicesDeliveryChannelActions.upsertCitizensServicesDeliveryChannels,
    (state, action) => adapter.upsertMany(action.citizensServicesDeliveryChannels, state)
  ),
  on(CitizensServicesDeliveryChannelActions.updateCitizensServicesDeliveryChannel,
    (state, action) => adapter.updateOne(action.citizensServicesDeliveryChannel, state)
  ),
  on(CitizensServicesDeliveryChannelActions.updateCitizensServicesDeliveryChannels,
    (state, action) => adapter.updateMany(action.citizensServicesDeliveryChannels, state)
  ),
  on(CitizensServicesDeliveryChannelActions.deleteCitizensServicesDeliveryChannel,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesDeliveryChannelActions.deleteCitizensServicesDeliveryChannels,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesDeliveryChannelActions.loadCitizensServicesDeliveryChannels,
    (state, action) => adapter.setAll(action.citizensServicesDeliveryChannels, state)
  ),
  on(CitizensServicesDeliveryChannelActions.clearCitizensServicesDeliveryChannels,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
